<template>
  <vs-row v-if="this.calldata[0]">
    <template v-for="(item,i) in Object.keys(read[0].control)">
      <vs-col vs-lg="3" vs-xs="6" v-if="read[0].control[item]['visible']"  :key="i" style="padding: 2%">
        <vs-card v-if="windowWidth > 600">
          <h4 class="card-title d-flex" style="color: #333f50">
            {{item}}
          </h4>
          <p style="text-align: center; font-size: 350%;" v-if="read[0].control[item]['value'] == true">
            ON
          </p>
          <p style="text-align: center; font-size: 350%;" v-if="read[0].control[item]['value'] == false">
            OFF
          </p>
        </vs-card>
        <vs-card v-else>
          <h6 class="card-title d-flex" style="color: #333f50">
            {{item}}
          </h6>
          <p style="text-align: center; font-size: 150%;" v-if="read[0].control[item]['value'] == true">
            ON
          </p>
          <p style="text-align: center; font-size: 150%;" v-if="read[0].control[item]['value'] == false">
            OFF
          </p>
        </vs-card>
      </vs-col>
    </template>
    <vs-row vs-w="12">
      <vs-col vs-lg="12" vs-xs="12">
        <vs-card>
          <vs-table stripe :data="Object.keys(read[0].control)">
            <template slot="header">
            <h4>
              Control Switch
            </h4>
          </template>
          <template slot="thead">
            <vs-th style="padding: 0px">
              Name
            </vs-th>
            <vs-th style="padding: 0px">
              Status
            </vs-th>
            <vs-th style="padding: 0px">
              Switch
            </vs-th>
            <vs-th style="padding: 0px">
              Timestamp
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <template  v-for="(tr, indextr) in data">
            <vs-tr :key="indextr" v-if="read[0].control[data[indextr]]['visible']">
              <vs-td>
                {{data[indextr]}}
              </vs-td>
              <vs-td v-if="read[0].control[data[indextr]]['value'] == 1">
                ON
              </vs-td>
              <vs-td v-if="read[0].control[data[indextr]]['value'] == 0">
                OFF
              </vs-td>
              <vs-td>
                <vs-button type="filled" @click="btnChange(data[indextr],indextr)" v-if="read[0].control[data[indextr]]['visible']">Switch</vs-button>
              </vs-td>
              <vs-td v-if='read[0].jtimestamp["time"+indextr] != temp'>
                {{read[0].jtimestamp["time"+indextr]}}
              </vs-td>
              <vs-td v-if='read[0].jtimestamp["time"+indextr] == temp'>
                {{read[0].jtimestamp["time"+indextr]}}
              </vs-td>
            </vs-tr>
            </template>
          </template>
          </vs-table>
        </vs-card>
      </vs-col>
    </vs-row>
  </vs-row>
</template>
<script>
export default {
  name: "Control",
  props: [
    'id',
    'gid',
    'nwid',
    'type',
    'nwname'
  ],
  data: () => ({
    windowWidth: window.innerWidth,
    oldread: {},
    read: [],
    // read: {"id":0,"Timestamp":"2020-09-11 09:07:14.08393","serial_id":"000001","control":{"light1":1,"light2":0}},
    dataform: {
      data: '',
      date: 0,
    },
    temp: '',
    switch1: [true,false],
    calldata: []
  }),
  methods: {
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.windowResize();
    },
    windowResize() {
      if (this.windowWidth < 600) {
        // // console.log('small')
      } else {
        // // console.log('big')
      }
    },
    btnChange(item,i) {
      // console.log(this.$session.get('admin'))
      if(this.$session.get('admin') != 'poonsak.ngk') {
        this.$vs.notify({
          title: "You don't have permission here",
          text: "This control unit is make for NGK corp.",
          color: "danger",
          position: "top-center",
          icon: 'clear'
        });
      }else{
        var control = {}
        var date = Date.now()
        this.temp = date
        // console.log(item,!this.switch1[i].value)
        this.switch1[i].value = !this.switch1[i].value
        // console.log(this.switch1)
        this.read[0].jtimestamp["item"+i] = this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
        // // console.log(this.read[0].jtimestamp["item"+i])
        // // console.log(this.read[0].control[item])
        this.switch1.forEach((element,i) => {
          control[Object.keys(this.read[0].control)[i]] = element.value  
        });
        // console.log(control)
        this.$http.post(this.$url+'updatecontrol' , {
          control: control,
          serial_id: this.id,
          username: this.$session.get('username'),
          rack: item,
          value: !this.switch1[i].value,
          change: this.read[0].control[item]
        }).then((result) => {
          if(result) {
            this.$vs.loading()
            this.$vs.notify({
              title: "Update Status",
              text: "Successful!",
              color: "success",
              position: "top-center",
              icon: 'check'
            });
            setTimeout(() => {
              // this.$vs.loading.close()
              location.reload()
            }, 5000);  
          }
        }).catch((err) => {
          if(err) {
            this.$vs.notify({
              title: "Update Status was unsuccessful",
              text: "Something wrong.",
              color: "danger",
              position: "top-center",
              icon: 'clear'
            });
          }
        })
      }
    }
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.windowResize();
    var tempswitch = {}
    var conperm = []
    var check = false
    this.$http.get(this.$url+'sensordatalastcontrol/'+this.id+'/'+this.gid).then((result) => {
      this.$http.get(this.$url+'sensorinfo/'+this.id).then(ldata => {
        this.calldata = result.data
        conperm = this.$session.get('controlperm')
        // console.log(conperm)
        for(let i = 0;i<this.calldata.length;i++){
          this.read[i] = this.calldata[i];
        }
        this.read.forEach((element,i) => {
          Object.keys(element.jtimestamp).forEach(el => {
            this.read[i].jtimestamp[el] = this.$moment(this.$moment(this.read[i].jtimestamp[el]).subtract(7,'hours')).format('YYYY-MM-DD HH:mm:ss')
          });
        });
        this.oldread = this.read[0].control
        Object.keys(this.read[0].control).forEach((e,i) => {
          this.read[0].control[e] = {value: this.read[0].control[e],visible: true}
          this.switch1[i] = result.data[0].control[e]
        });
        this.read[0].control = JSON.parse(ldata.data[0].lastdata[0])
        Object.keys(this.read[0].control).forEach((e,i) => {
          if(conperm != null) {
            conperm.forEach(con => {
              if(con == e) {
                check = true
              }
            })
          }else{
            this.read[0].control[e] = {value: this.read[0].control[e],visible: true}
          }
          if(check) {
            this.read[0].control[e] = {value: this.read[0].control[e],visible: true}
            check = false
          }else if(conperm) {
            this.read[0].control[e] = {value: this.read[0].control[e],visible: false}
            check = false
          }
          // this.switch1[i] = this.read[0].control[e]['value']
          // this.switch1[i] = result.data[0].control[e]
        });
        // console.log(this.read[0].control,this.switch1)
        // Object.keys(this.read.control).forEach((item) => {
        //   // eslint-disable-next-line no-console
        //   // console.log(this.read.control[item])
        // })
      })
    })
  }
};
</script>

